import moment from "moment/moment";
import React, { useEffect, useState } from "react";
import { useLocation } from "react-router-dom";
import FileViewer from "./FileViewer";

const initialState = {
  studentName: "",
  title: "",
  deadLinedate: "",
  submissionText: "",
  file: "",
  fileModal: "",
};
const SubmissonDetails = () => {
  const [iState, setUpdateState] = useState(initialState);
  const { studentName, title, deadLinedate, submissionText, file, fileModal } =
    iState;
  const { state } = useLocation();
  console.log({ state }, state?.challengeData?.[0]?.endDate);

  useEffect(() => {
    setUpdateState({
      studentName: state?.studentData?.fullName,
      title: state?.challengeData?.title || state?.challengeData?.[0]?.title,
      deadLinedate:
        state?.challengeData?.endDate || state?.challengeData?.[0]?.endDate,
      submissionText: state?.answer,
      file: state?.fileLink,
    });
  }, []);
  const handleChange = (e) => {
    setUpdateState({ ...iState, [e.target.name]: e.target.value });
  };
  console.log({ file });
  const hanldeClose = () => {
    setUpdateState({ ...iState, fileModal: false });
  };
  return (
    <>
      <div className="WrapperArea">
        <div className="WrapperBox">
          <div className="Small-Wrapper">
            <div className="TitleBox Border">
              <h4 className="Title">Answer details</h4>
            </div>
            <div className="CommonForm">
              <div className="form-group">
                <label>Name of Student (Auto-fill)</label>
                <input
                  type="text"
                  className="form-control"
                  placeholder="Name of Student"
                  name="studentName"
                  value={studentName}
                  disabled
                />
              </div>
              <div className="form-group">
                <label>Challenge Title (Auto-fill)</label>
                <input
                  type="text"
                  className="form-control"
                  placeholder="Title Name"
                  name="title"
                  value={title}
                  disabled
                />
              </div>
              <div className="form-group">
                <label>Deadline Date (Auto-fill)</label>
                <input
                  type="text"
                  className="form-control"
                  name="deadLinedate"
                  value={moment(deadLinedate).format("DD/MM/YYYY")}
                  disabled
                />
              </div>
              <div className="form-group">
                <label>Submission Text</label>
                <textarea
                  className="form-control"
                  placeholder="Write here"
                  rows={5}
                  name="submissionText"
                  value={submissionText}
                  disabled
                />
              </div>
              <div
                className="form-group"
                onClick={() =>
                  setUpdateState((prev) => ({
                    ...prev,
                    fileModal: true,
                  }))
                }
                style={{
                  cursor: "pointer",
                }}
              >
                <div className="ViewFile">
                  <span>
                    <img src={require("../../../assets/images/pdf.png")} />
                  </span>
                  <p>
                    <label>View File</label>
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      {fileModal && <FileViewer fileUrl={file} hanldeClose={hanldeClose} />}
    </>
  );
};

export default SubmissonDetails;
